import axiosClient from '../axiosClient';

export interface TimeEntry {
  id: string;
  taskId: string;
  userId: string;
  startTime: string;
  endTime?: string;
  duration?: number;
  description?: string;
  user?: {
    id: string;
    name: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface TimeTrackingSummary {
  total: number;
  entries: number;
}

export const timeTrackingApi = {
  // Start timer for a task
  startTimer: async (taskId: string, description?: string): Promise<TimeEntry> => {
    const response = await axiosClient.post(`/time-tracking/tasks/${taskId}/start`, {
      description,
    });
    return response.data;
  },

  // Stop timer
  stopTimer: async (entryId: string): Promise<TimeEntry> => {
    const response = await axiosClient.post(`/time-tracking/entries/${entryId}/stop`);
    return response.data;
  },

  // Get running timer
  getRunningTimer: async (): Promise<TimeEntry | null> => {
    const response = await axiosClient.get('/time-tracking/running');
    return response.data;
  },

  // Get time entries for a task
  getTaskEntries: async (taskId: string): Promise<TimeEntry[]> => {
    const response = await axiosClient.get(`/time-tracking/tasks/${taskId}/entries`);
    return response.data;
  },

  // Get total time for a task
  getTaskTotal: async (taskId: string): Promise<TimeTrackingSummary> => {
    const response = await axiosClient.get(`/time-tracking/tasks/${taskId}/total`);
    return response.data;
  },

  // Update time entry
  updateEntry: async (
    entryId: string,
    data: { description?: string; duration?: number }
  ): Promise<TimeEntry> => {
    const response = await axiosClient.patch(`/time-tracking/entries/${entryId}`, data);
    return response.data;
  },

  // Delete time entry
  deleteEntry: async (entryId: string): Promise<void> => {
    await axiosClient.delete(`/time-tracking/entries/${entryId}`);
  },

  // Get user's time entries
  getUserEntries: async (params?: {
    startDate?: string;
    endDate?: string;
    taskId?: string;
  }): Promise<TimeEntry[]> => {
    const response = await axiosClient.get('/time-tracking/entries', { params });
    return response.data;
  },
};
